import { render, staticRenderFns } from "./ProgramsSingleDetailsPlacementCard.vue?vue&type=template&id=5d3e14c9&"
import script from "./ProgramsSingleDetailsPlacementCard.vue?vue&type=script&lang=js&"
export * from "./ProgramsSingleDetailsPlacementCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports